module.exports = __webpack_public_path__ + "img/94.ef5af602.jpg";